import Model from '@/lib/data/Model';
import User from './User';

class MicroVisitLink extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'customer_id' },
        { name: 'user_id' },
        { name: 'visit_id' },
        { name: 'language_code' },
        { name: 'token' },
        { name: 'sms_sent' },
        { name: 'sms_content' },
        { name: 'email_sent' },
        { name: 'email_content' },
        { name: 'notes' },
        { name: 'expire_time' },
        { name: 'clicked_time' },
        { name: 'record_date_utc' },
        { name: 'modification_date_utc' },
        {
            name: 'user',
            mapping: 'user_id',
            association: {
                type: 'one',
                model: User,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'resend',
            url: '/microlist/operation/resend',
            params: ['id'],
        },
    ];
}

export default MicroVisitLink;
